import Environment from '@/constants/Environment';
import frCA from '@/i18n/locales/fr-CA';
import { createI18n, type IntlDateTimeFormat, type IntlNumberFormat } from 'vue-i18n';

const { Languages } = Environment;

const sharedDateAndTimeFormats: IntlDateTimeFormat = {
  longDate: {
    dateStyle: 'long',
  },
  longDateTime: {
    dateStyle: 'long',
    timeStyle: 'short',
  },
  shortDate: {
    dateStyle: 'short',
  },
  shortDateTime: {
    dateStyle: 'short',
    timeStyle: 'short',
  },
  shortTime: {
    timeStyle: 'short',
  },
};

const sharedNumberFormats: IntlNumberFormat = {
  currency: {
    currency: 'CAD',
    notation: 'standard',
    style: 'currency',
  },
  decimal: {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
  },
  percent: {
    style: 'percent',
    useGrouping: true,
  },
};

const i18n = createI18n({
  datetimeFormats: {
    [Languages.FR_CA]: { ...sharedDateAndTimeFormats },
  },
  fallbackLocale: Languages.FR_CA,
  globalInjection: false,
  legacy: false,
  locale: Languages.FR_CA,
  messages: {
    [Languages.FR_CA]: frCA,
  },
  numberFormats: {
    [Languages.FR_CA]: { ...sharedNumberFormats },
  },
});

const t = i18n.global.t;
const te = i18n.global.te;
const d = i18n.global.d;
const n = i18n.global.n;

export { d, i18n, n, t, te };
